import {getFontSize} from '@wix/wix-events-commons-statics'
import {AppProps} from '../types/props'

export const POPUP_LAYOUT_BREAKPOINT = 500
export const VERTICAL_POPUP_FULL_HEIGHT_BREAKPOINT = 700
export const SIDE_BY_SIDE_POPUP_FULL_HEIGHT_BREAKPOINT = 450

export const getShareFontSize = (context: Pick<AppProps, 'host'>): string => getFontSize(context.host.style, 'Body-M')
